import React from 'react'

const WorkRules = () => {
    return (
        <>WorkRules mobile</>
    )
}

export { WorkRules }